import type { RouteLocationNormalizedGeneric } from 'vue-router'
import { withQuery } from 'ufo'

export const useLoginReturnToMiddleware = () => {
  const router = useRouter()

  return {
    async navigateToLogin(route: RouteLocationNormalizedGeneric) {
      return navigateTo({
        path: '/login',
        query: {
          returnTo: route.name === 'login' ? undefined : withQuery(route.path, route.query),
        },
      })
    },
    async redirectFromLogin(route: RouteLocationNormalizedGeneric) {
      const fallback = '/account/main'

      let path

      if (route.name === 'login') {
        if (typeof route.query.returnTo === 'string' && route.query.returnTo.startsWith('/')) {
          path = route.query.returnTo
        }

        if (!path) {
          path = fallback
        }
      } else if (route.name === 'register') {
        path = fallback
      }

      if (!path) {
        if (import.meta.client) {
          window.location.reload()
          return
        } else {
          path = fallback
        }
      }

      const resolvedPath = router.resolve(path)
      return navigateTo(resolvedPath.fullPath, { external: true, replace: true })
    },
  }
}

export const useLoginReturnTo = () => {
  const route = useRoute()
  const app = useNuxtApp()
  const loginReturnToMiddleware = useLoginReturnToMiddleware()

  return {
    async navigateToLogin() {
      return app.runWithContext(() => loginReturnToMiddleware.navigateToLogin(route))
    },
    async redirectFromLogin() {
      return app.runWithContext(() => loginReturnToMiddleware.redirectFromLogin(route))
    },
  }
}
